import { useEffect } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { AuthProvider } from '../lib/useAuth';
import { trackPageView } from '../lib/analytics';

/** Top-level layout: admin auth context, GA4 page views, scroll restoration. */
export function RootLayout() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return (
    <AuthProvider>
      <ScrollRestoration />
      <Outlet />
    </AuthProvider>
  );
}
